import { Divider, TextField } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import { Box, Container, Grid } from "@mui/material";
import axios from "axios";
import {
  CurrencyNumberInput,
  CustomTable,
  DatePicker,
  FormLabel,
  ModalError,
  NumberInput,
  Page,
  PrimaryButton,
  SecondaryButton,
  SectionLabel,
  SelectInput,
  SkeletonComponent,
  SupportingDocumentForm,
  SwitchInput,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { arrayToCommaSeparatedString } from "utils";
import ContractTableMultipleRowInputCell from "./ContractTableMultipleRowInputCell";
import ModalAddSongContract from "./ModalAddSongContract";

function ContractForm(props) {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const preload = props?.preload;
  const preloadContractInformation = preload?.contract;
  const preloadSongs = preload?.songs;
  const preloadComposers = preload?.composers;
  const preloadAgents = preload?.agents;
  const isActiveContract = preloadContractInformation?.is_active_flag;
  const isPreloadApproved =
    preloadContractInformation?.approval_status === "approved";
  const isEditMode = Boolean(props?.contractId);
  const [contractType, setContractType] = useState("Song Contract");
  const [contractInformationForm, setContractInformationForm] = useState({
    contract_number: "",
    date_periode: 0,
    start_date: moment(),
    end_date: moment(),
    description: "",
    is_endless_period: false,
    type_periode: "days",
  });
  const [selectedSongTable, setSelectedSongTable] = useState([]);
  const [modalSongVisiblity, setModalSongVisiblity] = useState(false);

  const [contractComposerForm, setContractComposerForm] = useState({
    selectionsList: [],
    selectedFilter: {},
  });
  const [contractComposerParams, setContractComposerParams] = useState({
    page: 1,
    size: 100,
  });
  const [composerSelectionsList, setComposerSelectionsList] = useState([]);
  const [advanceValueForm, setAdvanceValueForm] = useState({
    status: preload?.has_advance || false,
    selectedFilter: 0,
    mainContractForm: {
      advance_balance: 0,
      start_period: moment(),
      end_period: moment(),
    },
  });
  const [advanceValueTable, setAdvanceValueTable] = useState([]);

  const [agentForm, setAgentForm] = useState({
    status: false,
    selectionsList: [],
    selectedFilter: 0,
    mainContractForm: {
      agent_id: 0,
      agent_percentage_value: 0,
      agent_fee_type: "sales_amount",
    },
  });
  const [agentTable, setAgentTable] = useState([]);
  const [supportingDocumentFiles, setSupportingDocumentFiles] = useState([]);
  const [publisherShareForm, setPublisherShareForm] = useState({
    value: 0,
    selectedFilter: 0,
  });
  const [deletedFiles, setDeletedFiles] = useState([]);

  const isSongContract = contractType === "Song Contract";
  const isPerpetual = contractInformationForm?.is_endless_period;

  const handleChangeContractInformationForm = (value, key) => {
    setContractInformationForm(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangeContractComposerForm = (value, key) => {
    setContractComposerForm(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangeComposerParams = (value, key) => {
    setContractComposerParams(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangeAdvanceValueForm = (value, key) => {
    setAdvanceValueForm(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangePeriodType = value => {
    handleChangeContractInformationForm(value, "type_periode");
    if (value === "days") {
      handleChangeContractInformationForm(
        changeDate(
          contractInformationForm?.start_date,
          contractInformationForm?.date_periode
        ),
        "end_date"
      );
    } else {
      handleChangeContractInformationForm(
        changeYear(
          contractInformationForm?.start_date,
          contractInformationForm?.date_periode
        ),
        "end_date"
      );
    }
  };
  const handleChangeTimePeriod = number => {
    const value = parseInt(number) || 0;
    handleChangeContractInformationForm(value, "date_periode");
    if (contractInformationForm?.type_periode === "days") {
      handleChangeContractInformationForm(
        changeDate(contractInformationForm?.start_date, value),
        "end_date"
      );
    } else {
      handleChangeContractInformationForm(
        changeYear(contractInformationForm?.start_date, value),
        "end_date"
      );
    }
  };
  const handleAddSong = async song => {
    const selectedId = song?.song_id;
    const isSongSelected = selectedSongTable.some(
      item => item.song_id === selectedId
    );

    setSelectedSongTable(prevSelectedSongTable => {
      let updatedSelectedSongTable;

      if (isSongSelected) {
        updatedSelectedSongTable = prevSelectedSongTable.filter(
          item => item.song_id !== selectedId
        );
      } else {
        const updatedSongComposers = song.song_composer?.map(composer => ({
          ...composer,
          advance_balance: 0,
          start_period: moment(),
          end_period: moment(),
          agent_id: 0,
          agent_percentage_value: 0,
          agent_fee_type: "sales_amount",
        }));

        updatedSelectedSongTable = [
          ...prevSelectedSongTable,
          {
            ...song,
            song_composer: updatedSongComposers,
          },
        ];
      }

      const newDataAdvanceValueList = updatedSelectedSongTable?.flatMap(item =>
        item?.song_composer?.map(composer => ({
          sure_name: composer?.composer?.sure_name,
          song_id: composer?.song_id,
          composer_id: composer?.composer_id,
        }))
      );
      const uniqueSongComposersMap = new Map();
      newDataAdvanceValueList.forEach(item => {
        uniqueSongComposersMap.set(item.sure_name, item);
      });

      const uniqueSongComposersList = Array.from(
        uniqueSongComposersMap.values()
      );
      setComposerSelectionsList(uniqueSongComposersList);

      return updatedSelectedSongTable;
    });
  };
  const handleDeleteComposer = async (composerId, songId) => {
    const updatedSelectedSongTable = selectedSongTable?.map(item => {
      if (item.song_id === songId) {
        return {
          ...item,
          song_composer: item.song_composer?.filter(
            songComposer => songComposer?.composer?.composer_id !== composerId
          ),
        };
      }
      return item;
    });

    const isComposerUsedInOtherSongs = updatedSelectedSongTable?.some(item =>
      item.song_composer?.some(
        songComposer => songComposer?.composer?.composer_id === composerId
      )
    );

    if (!isComposerUsedInOtherSongs) {
      const updatedComposerSelectionsList = composerSelectionsList.filter(
        composer => composer?.composer_id !== composerId
      );
      setComposerSelectionsList(updatedComposerSelectionsList);
    }

    setAdvanceValueTable(
      filterSelectedSongsByComposerId(
        updatedSelectedSongTable,
        advanceValueForm?.selectedFilter
      )
    );

    setAgentTable(
      filterSelectedSongsByComposerId(
        updatedSelectedSongTable,
        agentForm?.selectedFilter
      )
    );

    setSelectedSongTable(updatedSelectedSongTable);
  };
  const handleChangeShareValue = (value, selectedSong, key) => {
    setSelectedSongTable(prev =>
      prev.map(song =>
        song?.song_id === selectedSong?.song_id
          ? {
              ...song,
              song_composer: song?.song_composer?.map(composer =>
                composer?.composer_id === selectedSong?.composer_id
                  ? { ...composer, [key]: Number(value) }
                  : composer
              ),
            }
          : song
      )
    );
  };
  const handleSelectAdvanceValue = value => {
    handleChangeAdvanceValueForm(value, "selectedFilter");
    setAdvanceValueTable(
      filterSelectedSongsByComposerId(selectedSongTable, value)
    );
  };
  const handleChangeValueAdvance = (value, selectedSong, key) => {
    const { selectedFilter } = advanceValueForm;
    setSelectedSongTable(prevList =>
      prevList.map(song =>
        song?.song_id === selectedSong?.song_id
          ? {
              ...song,
              song_composer: song?.song_composer?.map(composer =>
                composer?.composer_id === selectedFilter
                  ? {
                      ...composer,
                      [key]: value,
                    }
                  : composer
              ),
            }
          : song
      )
    );
    setAdvanceValueTable(prevList =>
      prevList.map(song =>
        song?.song_id === selectedSong?.song_id
          ? {
              ...song,
              song_composer: song?.song_composer?.map(composer =>
                composer?.composer_id === selectedFilter
                  ? { ...composer, [key]: value }
                  : composer
              ),
            }
          : song
      )
    );
  };
  const handleChangeAdvanceValueMainContractForm = (value, key, subKey) => {
    setAdvanceValueForm(currentState => ({
      ...currentState,
      [key]: {
        ...currentState?.[key],
        [subKey]: value,
      },
    }));
  };
  const handleChangeAgentForm = (value, key) => {
    setAgentForm(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangePublisherShareForm = (value, key) => {
    setPublisherShareForm(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleSelectAgent = value => {
    handleChangeAgentForm(value, "selectedFilter");
    setAgentTable(filterSelectedSongsByComposerId(selectedSongTable, value));
  };
  const handleChangeAgentValue = (value, selectedSong, key) => {
    const { selectedFilter } = agentForm;
    setSelectedSongTable(prevList =>
      prevList.map(song =>
        song?.song_id === selectedSong?.song_id
          ? {
              ...song,
              song_composer: song?.song_composer?.map(composer =>
                composer?.composer_id === selectedFilter
                  ? {
                      ...composer,
                      [key]: value,
                    }
                  : composer
              ),
            }
          : song
      )
    );
    setAgentTable(prevList =>
      prevList.map(song =>
        song?.song_id === selectedSong?.song_id
          ? {
              ...song,
              song_composer: song?.song_composer?.map(composer =>
                composer?.composer_id === selectedFilter
                  ? { ...composer, [key]: Number(value) }
                  : composer
              ),
            }
          : song
      )
    );
  };
  const handleChangeAgentMainContractForm = (value, key, subKey) => {
    setAgentForm(currentState => ({
      ...currentState,
      [key]: {
        ...currentState?.[key],
        [subKey]: value,
      },
    }));
  };
  const handlePreloadSongs = preloadSongs => {
    const selectedSongData = [];

    preloadSongs.forEach(song => {
      const { song_id, title, composers } = song;
      const selectedSongComposers = composers.map(composer => {
        const composerData = preloadAgents.find(
          agent => agent.composer_id === composer.composer_id
        );
        const agent = composerData
          ? composerData.agents.find(agent => agent.song_id === song_id)
          : null;

        const { agent_id, fee, fee_type } = agent || {};

        return {
          composer_id: composer.composer_id,
          percentage_ownership: composer.ownership_percentage,
          publisher_share: composer.publisher_share,
          composer: {
            sure_name: composer.composer_name,
          },
          ContractComposerID: composer.song_balance.ContractComposerID,
          song_id: composer.song_balance.song_id,
          song_title: composer.song_balance.song_title,
          advance_balance: composer.song_balance.balance,
          balance_formatted: composer.song_balance.balance_formatted,
          start_period: getPreloadDate(composer.song_balance.start_period),
          end_period: getPreloadDate(composer.song_balance.end_period),
          contract_advance_flag: composer.contract_advance_flag,
          contract_publisher_share_flag: composer.contract_publisher_share_flag,
          agent_id: agent_id || 0,
          agent_percentage_value: fee || 0,
          agent_fee_type: fee_type || "sales_amount",
        };
      });

      selectedSongData.push({
        song_id,
        title_song: title,
        song_composer: selectedSongComposers,
      });
    });

    setSelectedSongTable(selectedSongData);
  };
  const getPreload = async () => {
    setSupportingDocumentFiles(props?.documentList || []);
    setContractType(props?.stateContractType);
    setContractInformationForm(prevState => ({
      ...prevState,
      type_periode: preloadContractInformation?.type_periode,
      contract_number: preloadContractInformation?.contract_number || "",
      date_periode: preloadContractInformation?.date_period || 0,
      start_date: preloadContractInformation?.start_date
        ? getPreloadDate(preloadContractInformation?.start_date)
        : moment(),
      end_date: preloadContractInformation?.end_date
        ? getPreloadDate(preloadContractInformation?.end_date)
        : moment(),
      description: preloadContractInformation?.description || "",
      is_endless_period: preloadContractInformation?.is_endless_period || false,
    }));
    setComposerSelectionsList(preloadComposers);
    if (preloadSongs) {
      handlePreloadSongs(preloadSongs);
      handleChangeAdvanceValueForm(preload?.has_advance, "status");
      handleChangeAdvanceValueForm(
        preloadSongs[0]?.composers[0]?.composer_id,
        "selectedFilter"
      );
    }

    if (!isSongContract) {
      const preloadAdvanceValue =
        preloadContractInformation?.contract_composer_balance;
      const preloadAgent = preloadContractInformation?.contract_composer_agent;

      const preloadContractComposer = {
        composer_id: preloadContractInformation?.composer?.composer_id,
        composer_name: preloadContractInformation?.composer?.sure_name,
        phone_number: preloadContractInformation?.composer?.phone_number,
      };
      const preloadAdvanceValueForm = {
        advance_balance: preloadAdvanceValue?.balance,
        start_period: preloadAdvanceValue?.start_period
          ? getPreloadDate(preloadAdvanceValue?.start_period)
          : moment(),
        end_period: preloadAdvanceValue?.end_period
          ? getPreloadDate(preloadAdvanceValue?.end_period)
          : moment(),
      };
      const preloadAgentForm = {
        agent_id: preloadAgent?.agent_id,
        agent_percentage_value: Number(preloadAgent?.agent_fee_formatted),
        agent_fee_type: preloadAgent?.fee_type,
      };
      handleChangeContractComposerForm(
        preloadContractComposer,
        "selectedFilter"
      );

      handleChangeAdvanceValueForm(preloadAdvanceValueForm, "mainContractForm");

      handleChangePublisherShareForm(
        preloadContractInformation?.publisher_share_percentage,
        "value"
      );

      handleChangeAgentForm(!preloadAgent?.is_agent_deleted, "status");
      handleChangeAgentForm(preloadAgentForm, "mainContractForm");
    }
  };
  const validatePayload = () => {
    const errors = [];
    const errorEmpty = err => `${err} can't be empty.`;

    if (!contractInformationForm.contract_number) {
      errors.push(errorEmpty("Contract Number"));
    }

    const hasNoComposers =
      !isSongContract &&
      !Object.keys(contractComposerForm?.selectedFilter || {}).length;
    const hasNoSongs = isSongContract && !selectedSongTable.length;

    if (hasNoComposers) {
      errors.push(errorEmpty("Composer"));
    } else if (hasNoSongs) {
      errors.push(errorEmpty("Song"));
    }

    return errors;
  };
  const handleRemoveFile = (file, idx) => {
    if (file && typeof file === "object" && "contract_document_id" in file) {
      setDeletedFiles(prev => [...prev, Number(file.contract_document_id)]);
    }

    setSupportingDocumentFiles(
      supportingDocumentFiles?.filter((_, index) => index !== idx)
    );
  };

  const getAgentList = () => {
    axios
      .get(`${hardBaseUrl}/publisher/agent-on-transaction`, { headers })
      .then(res => {
        handleChangeAgentForm(res?.data?.data, "selectionsList");
      });
  };
  const getComposerList = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/publisher/composer`, {
        headers,
        params: contractComposerParams,
      });
      handleChangeContractComposerForm(res?.data?.data, "selectionsList");
    } catch (error) {
      console.error("Error fetching composer list:", error);
    }
  };
  const handleSubmit = event => {
    event?.preventDefault();

    const payloadAdvanceValueList = selectedSongTable?.flatMap(song => {
      return song?.song_composer?.map(composer => ({
        composer_id: composer?.composer_id,
        song_id: composer?.song_id,
        balance: composer?.advance_balance,
        start_period: getDateFormatForFilter(composer?.start_period),
        end_period: getDateFormatForFilter(composer?.end_period),
      }));
    });
    const payloadAdvanceValueMainContract = {
      balance: advanceValueForm?.mainContractForm?.advance_balance,
      start_period: getDateFormatForFilter(
        advanceValueForm?.mainContractForm?.start_period
      ),
      end_period: getDateFormatForFilter(
        advanceValueForm?.mainContractForm?.end_period
      ),
    };
    const payloadOwnershipPercentage = selectedSongTable?.map(song => ({
      song_id: song?.song_id,
      composer_share_percentages: song?.song_composer?.map(composer => ({
        composer_id: composer?.composer_id,
        ownership_percentage: Number(composer?.percentage_ownership) || 0,
      })),
    }));
    const payloadPublisherShare = (() => {
      const composerMap = {};
      selectedSongTable?.forEach(item => {
        item.song_composer?.forEach(composer => {
          const { composer_id, song_id, publisher_share } = composer;
          if (!composerMap[composer_id]) {
            composerMap[composer_id] = [];
          }
          composerMap[composer_id].push({
            song_id,
            percentage: publisher_share,
          });
        });
      });
      return Object.entries(composerMap).map(
        ([composer_id, song_percentages]) => ({
          composer_id: Number(composer_id),
          song_percentages,
        })
      );
    })();
    const payloadAgentList = selectedSongTable?.flatMap(song => {
      return song?.song_composer?.map(composer => ({
        song_id: song?.song_id,
        composer_id: composer?.composer_id,
        agent_id: composer?.agent_id,
        agent_fee: composer?.agent_percentage_value,
        fee_type: composer?.agent_fee_type,
      }));
    });
    const payloadAgentMainContract = {
      ...agentForm?.mainContractForm,
      agent_fee: agentForm?.mainContractForm?.agent_percentage_value,
      fee_type: agentForm?.mainContractForm?.agent_fee_type,
    };

    const payload = {
      contract_number: contractInformationForm?.contract_number,
      date_periode: contractInformationForm?.date_periode,
      start_date: getDateFormatForFilter(contractInformationForm?.start_date),
      end_date: getDateFormatForFilter(contractInformationForm?.end_date),
      description: contractInformationForm?.description,
      is_endless_period: isPerpetual,
      type_periode: contractInformationForm?.type_periode,
      ...(deletedFiles?.length > 0 && {
        deleted_contract_docs: arrayToCommaSeparatedString(deletedFiles),
      }),
      ...(isSongContract
        ? {
            ...(advanceValueForm?.status && {
              contract_composer_balances: payloadAdvanceValueList,
            }),
            ownership_percentages: payloadOwnershipPercentage,
            publisher_share_percentages: payloadPublisherShare,
            ...(agentForm?.status && {
              contract_composer_agents: payloadAgentList,
            }),
          }
        : {
            ...(advanceValueForm?.status && {
              contract_composer_balance: payloadAdvanceValueMainContract,
            }),
            composer_id: contractComposerForm?.selectedFilter?.composer_id,
            publisher_share_percentage: Number(publisherShareForm?.value),
            ...(agentForm?.status && {
              contract_composer_agent: payloadAgentMainContract,
            }),
          }),
    };

    const errors = validatePayload();

    if (errors?.length) {
      ModalError(errors[0]);
      return;
    }
    props?.handlSubmitData(payload, supportingDocumentFiles, contractType);
  };

  useEffect(() => {
    getAgentList();
  }, []);
  useEffect(() => {
    if (isEditMode) handleSelectAdvanceValue(advanceValueForm.selectedFilter);
  }, [selectedSongTable, advanceValueForm.selectedFilter]);
  useEffect(() => {
    if (isEditMode && !props?.loadingContract) {
      getPreload();
    }
  }, [preload]);
  useEffect(() => {
    getComposerList();
  }, [contractComposerParams]);

  return (
    <Page className={classes?.root} title={props?.title}>
      {props?.loadingContract ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={props?.title}
            breadcrumbData={breadcrumbData(props?.title)}
            backButton
          />
          <Divider className={classes?.divider} />
          <SectionLabel
            title="Contract Type"
            subTitle="Feature to select type of contract between main or song contract"
            mb="16px"
          />
          <SelectInput
            value={contractType}
            options={optionsContractType}
            onChange={event => setContractType(event?.target?.value)}
            optionKey="name"
            optionLabel="name"
            width={300}
            disabled={isEditMode}
          />
          <Divider className={classes?.divider} />
          <SectionLabel
            title={`${isSongContract ? "Song" : "Main"} Contract Information`}
            subTitle="Form to fill out information data related to the contract to be made"
            mb="20px"
          />
          <Grid container columnSpacing={1}>
            {buttonPeriod?.map(item =>
              contractInformationForm?.type_periode === item?.value ? (
                <Grid item key={item?.value}>
                  <PrimaryButton
                    label={item?.label}
                    onClick={() => handleChangePeriodType(item?.value)}
                    width={100}
                  />
                </Grid>
              ) : (
                <Grid item key={item?.value}>
                  <SecondaryButton
                    label={item?.label}
                    onClick={() => handleChangePeriodType(item?.value)}
                    width={100}
                  />
                </Grid>
              )
            )}
          </Grid>
          <Box border="1px solid #9AA2B1" borderRadius="6px" p="24px" my="20px">
            <Grid container columnSpacing="16px" rowSpacing="8px">
              <Grid item xs={6}>
                <FormLabel label="Contract Number" required />
                <TextInput
                  placeholder="Contract Number"
                  onChange={event =>
                    handleChangeContractInformationForm(
                      event?.target?.value,
                      "contract_number"
                    )
                  }
                  value={contractInformationForm?.contract_number}
                  disabled={isEditMode && isPreloadApproved}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <FormLabel label="Time Period" required />
                <NumberInput
                  placeholder={0}
                  onChange={value => handleChangeTimePeriod(Number(value))}
                  disabled={
                    isPerpetual ||
                    (isEditMode && isPreloadApproved && !isActiveContract)
                  }
                  endAdornment={
                    contractInformationForm?.type_periode === "days"
                      ? "Days"
                      : "Years"
                  }
                  value={contractInformationForm?.date_periode}
                />
              </Grid>
              <Grid item xs={6}>
                <FormLabel label="Start Date" required />
                <DatePicker
                  disabled={isEditMode && isPreloadApproved}
                  value={contractInformationForm?.start_date}
                  onChange={date => {
                    handleChangeContractInformationForm(date, "start_date");
                    if (contractInformationForm?.type_periode === "days") {
                      handleChangeContractInformationForm(
                        changeDate(
                          date,
                          Number(contractInformationForm?.date_periode)
                        ),
                        "end_date"
                      );
                    } else {
                      handleChangeContractInformationForm(
                        changeYear(
                          date,
                          Number(contractInformationForm?.date_periode)
                        ),
                        "end_date"
                      );
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <FormLabel label="End Date" required />
                <DatePicker
                  label={isPerpetual ? "Perpetual" : null}
                  disabled
                  value={isPerpetual ? null : contractInformationForm?.end_date}
                />
                <Box mt="8px">
                  <SwitchInput
                    label="This contract will perpetuity"
                    checked={contractInformationForm?.is_endless_period}
                    onChange={() =>
                      handleChangeContractInformationForm(
                        !contractInformationForm?.is_endless_period,
                        "is_endless_period"
                      )
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <FormLabel label="Description" />
                <TextInput
                  placeholder="Description"
                  onChange={event =>
                    handleChangeContractInformationForm(
                      event?.target?.value,
                      "description"
                    )
                  }
                  value={contractInformationForm?.description}
                  multiline
                  minRows={10}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
          <Grid container justifyContent="space-between">
            <Grid item>
              <SectionLabel
                title={isSongContract ? "Song" : "Composer"}
                subTitle={
                  isSongContract
                    ? "This feature can add multiple songs with multiple composer/author in contract"
                    : "This feature can add composer in one contract"
                }
                mb="20px"
              />
            </Grid>
            {isSongContract && (
              <Grid item>
                <PrimaryButton
                  startIcon={<Add />}
                  label="Add Song"
                  onClick={() => setModalSongVisiblity(true)}
                  size="large"
                />
              </Grid>
            )}
          </Grid>
          {isSongContract ? (
            <CustomTable
              columnTable={columnTableSongContract({
                handleDeleteComposer,
                handleChangeShareValue,
              })}
              data={selectedSongTable}
            />
          ) : (
            <Autocomplete
              onChange={(_, value) => {
                if (value) {
                  handleChangeContractComposerForm(value, "selectedFilter");
                } else {
                  handleChangeContractComposerForm("", "selectedFilter");
                }
              }}
              options={contractComposerForm?.selectionsList}
              value={contractComposerForm?.selectedFilter}
              getOptionLabel={option => option?.sure_name || ""}
              renderInput={params => (
                <TextField
                  {...params}
                  value={contractComposerForm?.selectedFilter?.sure_name || ""}
                  onChange={event => {
                    handleChangeComposerParams(event?.target?.value, "search");
                  }}
                  variant="outlined"
                  placeholder="Search Composer/Author"
                />
              )}
            />
          )}
          <Grid container justifyContent="space-between" my="20px">
            <Grid item>
              <SectionLabel
                title="Advance Value"
                subTitle="Feature to set Advance Payment"
              />
            </Grid>
            {isSongContract && advanceValueForm?.status && (
              <Grid item>
                <SelectInput
                  label="Composer"
                  placeholder="None"
                  value={advanceValueForm?.selectedFilter || ""}
                  options={composerSelectionsList}
                  onChange={event =>
                    handleSelectAdvanceValue(event?.target?.value)
                  }
                  optionKey="composer_id"
                  optionLabel="sure_name"
                  width={200}
                />
              </Grid>
            )}
          </Grid>
          <SwitchInput
            label="Set Advance Value For Composer/Author"
            checked={advanceValueForm?.status}
            onChange={() =>
              handleChangeAdvanceValueForm(!advanceValueForm?.status, "status")
            }
          />
          {advanceValueForm?.status && advanceValueTable && (
            <CustomTable
              columnTable={columnTableAdvanceValue({
                isSongContract,
                handleChangeValueAdvance,
                handleChangeAdvanceValueMainContractForm,
                advanceValueForm,
              })}
              data={
                isSongContract
                  ? advanceValueTable
                  : [advanceValueForm?.mainContractForm]
              }
              my="16px"
            />
          )}
          {!isSongContract && (
            <Grid container justifyContent="space-between" my="20px">
              <Grid item>
                <SectionLabel
                  title="Publisher Share Percentage"
                  subTitle="Feature to set Publisher Share Percentage"
                />
              </Grid>
              <Grid item>
                <NumberInput
                  value={publisherShareForm?.value}
                  onChange={value =>
                    handleChangePublisherShareForm(Number(value), "value")
                  }
                  endAdornment="%"
                />
              </Grid>
            </Grid>
          )}
          <Grid container justifyContent="space-between" my="20px">
            <Grid item>
              <SectionLabel
                title="Agent"
                subTitle="Feature to set Agent & Fee Agent"
              />
            </Grid>
            {isSongContract && agentForm?.status && (
              <Grid item>
                <SelectInput
                  label="Composer"
                  placeholder="None"
                  value={agentForm?.selectedFilter || ""}
                  options={composerSelectionsList}
                  onChange={event => handleSelectAgent(event?.target?.value)}
                  optionKey="composer_id"
                  optionLabel="sure_name"
                  width={200}
                />
              </Grid>
            )}
          </Grid>
          <SwitchInput
            label="Is Agent engaged ?"
            checked={agentForm?.status}
            onChange={() => handleChangeAgentForm(!agentForm?.status, "status")}
          />
          {agentForm?.status && agentTable && (
            <CustomTable
              columnTable={columnTableAgent({
                isSongContract,
                agentForm,
                handleChangeAgentValue,
                handleChangeAgentMainContractForm,
                isPreloadApproved,
              })}
              data={isSongContract ? agentTable : [agentForm?.mainContractForm]}
              my="16px"
            />
          )}
          <Box my="20px">
            <SectionLabel
              title="Supporting Document"
              subTitle="Upload supporting documents, such as scanned agreement documents or can be in the form of pdf files"
              mb="20px"
            />
            <SupportingDocumentForm
              multiple
              supportingDocumentFiles={supportingDocumentFiles}
              setSupportingDocumentFiles={setSupportingDocumentFiles}
              handleRemoveFile={handleRemoveFile}
              maxFileSize={2000000}
            />
          </Box>
          <Box display="flex" justifyContent="flex-end">
            <PrimaryButton
              onClick={handleSubmit}
              label={isEditMode ? "Save Contract" : props?.title}
              size="large"
            />
          </Box>
          <ModalAddSongContract
            visiblity={modalSongVisiblity}
            handleClose={() => setModalSongVisiblity(false)}
            preloadId={preloadContractInformation?.contract_id}
            selectedSong={selectedSongTable}
            rowClick={value => handleAddSong(value)}
          />
        </Container>
      )}
    </Page>
  );
}

const changeDate = (init, value) => moment(init).add(value, "days");
const changeYear = (init, value) => moment(init).add(value, "years");
const getPreloadDate = date => moment(date, "YYYY-MM-DD");
const getDateFormatForFilter = date =>
  !date ? "" : moment(date).format("YYYY-MM-DD");
const filterSelectedSongsByComposerId = (songList, composerId) => {
  return songList?.filter(song =>
    song?.song_composer?.some(composer => composer?.composer_id === composerId)
  );
};
const getValueSongComposer = (song, filter, key) => {
  const composer = song?.song_composer?.find(
    composer => composer?.composer_id === filter
  );
  return composer ? composer[key] || "" : "";
};
const breadcrumbData = title => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Contract",
    link: "/admin/kontrak-composer",
  },
  {
    label: title,
    active: true,
  },
];
const optionsContractType = [
  { name: "Song Contract" },
  { name: "Main Contract" },
];
const optionsFeeCalucationBasis = [
  { name: "Sales Amount", value: "sales_amount" },
  { name: "Net Revenue Amount", value: "net_revenue_amount" },
];
const buttonPeriod = [
  { value: "days", label: "Day" },
  { value: "year", label: "Year" },
];
const columnTableSongContract = ({
  handleDeleteComposer,
  handleChangeShareValue,
}) => [
  {
    name: "title_song",
    title: "Song",
  },
  {
    name: "all",
    title: "Composer/Author Name",
    renderText: item => (
      <ContractTableMultipleRowInputCell
        list={item.song_composer}
        handleDeleteComposer={handleDeleteComposer}
        handleChangeShareValue={handleChangeShareValue}
      />
    ),
  },
  {
    name: "iswc_code",
    title: "ISWC Code",
  },
  {
    name: "all",
    title: "Publisher Share Percentages",
    renderText: item => (
      <ContractTableMultipleRowInputCell
        list={item.song_composer}
        type="input"
        itemKey="publisher_share"
        handleDeleteComposer={handleDeleteComposer}
        handleChangeShareValue={handleChangeShareValue}
      />
    ),
  },
  {
    name: "all",
    title: "Ownership Share Percentages",
    renderText: item => (
      <ContractTableMultipleRowInputCell
        list={item.song_composer}
        type="input"
        itemKey="percentage_ownership"
        handleDeleteComposer={handleDeleteComposer}
        handleChangeShareValue={handleChangeShareValue}
      />
    ),
  },
];
const columnTableAdvanceValue = ({
  isSongContract,
  handleChangeValueAdvance,
  handleChangeAdvanceValueMainContractForm,
  advanceValueForm,
}) => [
  ...(isSongContract
    ? [
        {
          name: "title_song",
          title: "Song",
        },
      ]
    : []),
  {
    name: "all",
    title: "Advance Value",
    renderText: song => (
      <CurrencyNumberInput
        value={
          isSongContract
            ? getValueSongComposer(
                song,
                advanceValueForm?.selectedFilter,
                "advance_balance"
              ) || 0
            : song?.advance_balance
        }
        onChange={value =>
          isSongContract
            ? handleChangeValueAdvance(Number(value), song, "advance_balance")
            : handleChangeAdvanceValueMainContractForm(
                Number(value),
                "mainContractForm",
                "advance_balance"
              )
        }
        startAdornment="Rp"
      />
    ),
    width: 300,
  },
  // {
  //   name: "all",
  //   title: "Start Period",
  //   renderText: song => (
  //     <DatePicker
  //       value={
  //         isSongContract
  //           ? getValueSongComposer(
  //               song,
  //               advanceValueForm?.selectedFilter,
  //               "start_period"
  //             )
  //           : song?.start_period
  //       }
  //       onChange={date =>
  //         isSongContract
  //           ? handleChangeValueAdvance(date, song, "start_period")
  //           : handleChangeAdvanceValueMainContractForm(
  //               date,
  //               "mainContractForm",
  //               "start_period"
  //             )
  //       }
  //     />
  //   ),
  //   width: 250,
  // },
  // {
  //   name: "all",
  //   title: "End Period",
  //   renderText: song => (
  //     <DatePicker
  //       value={
  //         isSongContract
  //           ? getValueSongComposer(
  //               song,
  //               advanceValueForm?.selectedFilter,
  //               "end_period"
  //             )
  //           : song?.end_period
  //       }
  //       onChange={date =>
  //         isSongContract
  //           ? handleChangeValueAdvance(date, song, "end_period")
  //           : handleChangeAdvanceValueMainContractForm(
  //               date,
  //               "mainContractForm",
  //               "end_period"
  //             )
  //       }
  //     />
  //   ),
  // width: 250,
  // },
];
const columnTableAgent = ({
  isSongContract,
  agentForm,
  handleChangeAgentValue,
  handleChangeAgentMainContractForm,
  isPreloadApproved,
}) => [
  ...(isSongContract
    ? [
        {
          name: "title_song",
          title: "Song",
        },
      ]
    : []),
  {
    name: "all",
    title: "Agent",
    renderText: song => (
      <SelectInput
        label="Agent"
        value={
          isSongContract
            ? getValueSongComposer(
                song,
                agentForm?.selectedFilter,
                "agent_id"
              ) || ""
            : song?.agent_id || ""
        }
        onChange={e =>
          isSongContract
            ? handleChangeAgentValue(e?.target?.value, song, "agent_id")
            : handleChangeAgentMainContractForm(
                e?.target?.value,
                "mainContractForm",
                "agent_id"
              )
        }
        optionKey="agent_id"
        optionLabel="name"
        options={agentForm?.selectionsList}
        placeholder="None"
        disabled={isPreloadApproved}
        width="100%"
      />
    ),
    width: 300,
  },
  {
    name: "all",
    title: "Agent Fee",
    renderText: song => (
      <NumberInput
        value={
          isSongContract
            ? getValueSongComposer(
                song,
                agentForm?.selectedFilter,
                "agent_percentage_value"
              )
            : song?.agent_percentage_value
        }
        onChange={value =>
          isSongContract
            ? handleChangeAgentValue(
                Number(value),
                song,
                "agent_percentage_value"
              )
            : handleChangeAgentMainContractForm(
                Number(value),
                "mainContractForm",
                "agent_percentage_value"
              )
        }
        endAdornment="%"
        disabled={isPreloadApproved}
      />
    ),
    width: 200,
  },
  {
    name: "all",
    title: "Fee Calculation Basis",
    renderText: song => (
      <SelectInput
        value={
          isSongContract
            ? getValueSongComposer(
                song,
                agentForm?.selectedFilter,
                "agent_fee_type"
              ) || "sales_amount"
            : song?.agent_fee_type || "sales_amount"
        }
        onChange={e =>
          isSongContract
            ? handleChangeAgentValue(e?.target?.value, song, "agent_fee_type")
            : handleChangeAgentMainContractForm(
                e?.target?.value,
                "mainContractForm",
                "agent_fee_type"
              )
        }
        optionKey="value"
        optionLabel="name"
        options={optionsFeeCalucationBasis}
        disabled={isPreloadApproved}
        width={300}
      />
    ),
  },
];
export default ContractForm;
